import React, { useState } from "react";
import styles from "./styles.module.scss";

const USE_CASES = [
  {
    id: "analytics",
    tab: "Data Analytics",
    title: "Data Analytics",
    description: "Make data-driven decisions",
    video: "https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/use+case/Data+Analytics.webm",
  },
  {
    id: "career",
    tab: "Career Growth",
    title: "Career Growth",
    description: "Advance your career with AI-powered tools",
    video: "https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/use+case/Career+Development.webm",
  },
  {
    id: "marketing",
    tab: "Marketing",
    title: "Marketing",
    description: "Supercharge your marketing campaigns",
    video: "https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/use+case/Marketing+.webm",
  },
  {
    id: "study",
    tab: "Study",
    title: "Study",
    description: "Enhance your learning experience",
    video: "https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/use+case/Study.webm",
  },
  {
    id: "productivity",
    tab: "Productivity",
    title: "Productivity",
    description: "Boost your daily productivity",
    video: "https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/use+case/Productivity.webm",
  },
  {
    id: "daily-life",
    tab: "Daily Life",
    title: "Daily Life",
    description: "Simplify your everyday tasks",
    video: "https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/use+case/Daily+Life.webm",
  },
];

interface UserCaseSectionProps {
  onDownloadClick: () => void;
}

/**
 * 用户案例展示部分组件
 * 显示各种使用场景和相应视频
 */
const UserCaseSection = ({ onDownloadClick }: UserCaseSectionProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeUseCase, setActiveUseCase] = useState(USE_CASES[0].id);

  // Use case change handler
  const handleUseCaseChange = (newActiveId: string) => {
    setActiveUseCase(newActiveId);
    const newIndex = USE_CASES.findIndex(useCase => useCase.id === newActiveId);
    if (newIndex !== -1) {
      setActiveIndex(newIndex);
    }
  };

  const currentUseCase = USE_CASES[activeIndex];

  return (
    <div className={styles.container}>
      {/* <h1>What Fellou Can Do For You</h1>
      <p>Discover more →</p> */}
      <h2 className={styles.sectionTitle}>What Fellou Can Do For You</h2>
      <p className={styles.sectionSubtitle}>
        <a href="/use-cases" className={styles.discoverMoreLink}>
          Discover more →
        </a>
      </p>
      <div className={styles.videoContainer}>
        <video
          key={currentUseCase.id}
          autoPlay
          muted
          loop
          playsInline
          className={styles.videoElement}>
          <source src={currentUseCase.video} type="video/mp4" />
        </video>
      </div>
      <div className={styles.useCaseTabs}>
        {USE_CASES.map((useCase, index) => (
          <button
            key={index}
            data-id={useCase.id}
            data-cursor-magnetic
            type="button"
            data-checked={useCase.id === activeUseCase}
            onClick={() => handleUseCaseChange(useCase.id)}
            className={styles.useCaseTab}>
            {useCase.tab}
          </button>
        ))}
      </div>
    </div>
  );
};

export default UserCaseSection;
